/** @fileoverview list_index_workers の共通定数 */

/** ツール名（単一参照点） */
export const LIST_INDEX_WORKERS_NAME = "list_index_workers" as const;

/** LLM へ提示する説明文 */
export const LIST_INDEX_WORKERS_DESC = `Retrieves all Index Workers belonging to a specific Index Worker project. Use this tool when a user asks for the workers defined inside a project, for example "Show every Index Worker inside project X." The tool returns read-only metadata for each Index Worker, including basic configuration like name, Search Console property, URL source, schedule, and URL group settings.`;
